module.exports = __webpack_public_path__ + "static/media/3.82ab7141.png";